import { RestSlice } from '../../../../../../redux/rest.slice';
import { Resource, localizationService } from 'src/services';
import { HaulerUser } from '@rcp/types';

export const manageHaulerAccessSlice = new RestSlice<HaulerUser>(
	localizationService.getLocalizedString('haulerPortal.settings.users.manageAccess'),
	Resource.ManageAccessHaulerUser
);
export default manageHaulerAccessSlice.rests.reducer;
